<template>
  <el-dialog
    :visible.sync="show"
    width="60"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :lock-scroll="true"
    class="el-dialog-v2"
  >
    <div class="news-popup">
      <div class="news-popup-strip blue">
        <div class="news-popup-strip yellow">
          <div class="news-popup-strip green">
            <div v-if="loading" class="news-popup--loader"></div>
            <template v-else>
              <div class="news-popup--content">
                <div class="news-popup--close" @click="show = false">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </div>
                <img :src="data.meta_data.logo_url" alt="Logo">
                <h1>{{ data.title }}</h1>
                <div class="countdown">
                  <span class="days"><span>{{  countdown.days }}</span>Days</span>
                  <span class="separator">:</span>
                  <span class="hours"><span>{{ countdown.hours }}</span>Hrs</span>
                  <span class="separator">:</span>
                  <span class="minutes"><span>{{ countdown.minutes }}</span>Mins</span>
                </div>
                <p>Time left before commencement</p>
                <p v-if="data.description" style="color: #1B1B1B;">({{ data.description }})</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from "element-ui";
export default {
  name: "NewsPopupV2",

  components: {
    ElDialog: Dialog
  },

  data() {
    return {
      loading: true,
      show: false,
      data: null,
    }
  },

  computed: {
    countdown() {
      if (!this.data) {
        return {
          days: "00",
          hours: "00",
          mins: "00"
        }
      }
      const deadline = new Date(this.data.meta_data.deadline)
      const now = new Date()
      const timeline = deadline - now;
      let duration = this.$moment.duration(timeline);

      const format = (value) => {
        return value < 10 ? `0${value}` : value
      }
      return {
        days: format(duration.days()),
        hours: format(duration.hours()),
        minutes: format(duration.minutes()),
      }
    }
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      this.$http
        .post("banners/login-popup",
          {
            method: "GET"
          }
        )
        .then(
          response => {
            if (response && response.data) {
              if (response.data.error) {
                this.notification(
                  response.data.message,
                  "pan_tool",
                  "danger"
                );
              } else {
                this.data = response.data;

                if (response.data) {
                  const { deadline } = response.data.meta_data;
                  const deadlineTime = new Date(deadline).getTime();
                  const now = new Date().getTime();

                  this.show = deadlineTime >= now;
                }
                this.loading = false;
              }
            } else {
              this.notification(
                "Something went wrong. Please try again.",
                "pan_tool",
                "danger"
              );
            }
          },
          error => {
            this.notification(error.message, "pan_tool", "danger");
          }
        );
    },
    notification(message, icon, color) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "right",
        verticalAlign: "top",
        type: color
      });
    },
  }
};
</script>

<style lang="scss">
@import "https://unpkg.com/element-ui/lib/theme-chalk/index.css";

.el-dialog-v2 {
  .el-dialog {
    border-radius: 12px !important;

    &__header {
      display: none;
    }

    &__body {
      padding: 0 !important;
    }

    .news-popup {
      position: relative;
      border: 6px solid #cc0e2f;
      border-radius: 12px;

      &-strip {
        border: 6px solid;
        border-radius: 8px;
        background: linear-gradient(180deg, #D5FDB1 0%, rgba(255, 255, 255, 0.60) 100%);

        &.blue {
          border-color: #0039a6;
        }

        &.yellow {
          border-color: #ffcb03;
        }

        &.green {
          border-color: #007837;
        }
      }

      &--loader {
        border: 5px solid;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border-color: #4caf50 transparent transparent;
        animation: spin 2s linear infinite;
        position: absolute;
        top: 40%;
        left: 45%;
      }

      &--close {
        background: #fff;
        height: 32px;
        width: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        position: absolute;
        top: -50px;
        right: -50px;
        cursor: pointer;
        transition: opacity 0.25s ease-in;

        &:hover {
          opacity: 1;
          transition: opacity 0.25s ease-out;
        }
      }

      &--content {
        min-height: 480px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 40px;

        img {
          height: 80px;
          width: auto;
        }

        h1 {
          font-family: "PT Serif", serif;
          word-break: break-word;
          margin: 20px auto 40px;
          font-size: 28px;
          text-align: center;
          text-transform: uppercase;
          font-weight: 600;
          line-height: 1.4;
          color: #1B1B1B;
          width: 90%;
        }

        p {
          word-break: break-word;
          font-size: 16px;
          font-weight: 500;
          color: #414141;
          text-align: center;
        }

        .countdown {
          background: #CC0C2F;
          border-radius: 6px;
          width: 350px;
          min-height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;

          span {
            font-weight: 600;
            font-size: 20px;

            span {
              font-size: 24px;
              margin-right: 5px;
            }

            &.separator {
              margin: 0 7px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1280px) {
  .el-dialog-v2 .el-dialog {
    width: 70% !important;
  }
}

@media (max-width: 1024px) {
  .el-dialog-v2 .el-dialog {
    width: 80% !important;

    .news-popup--content {
      min-height: 400px;
    }
  }
}

@media (max-width: 768px) {
  .el-dialog-v2 .el-dialog {
    width: 88% !important;
  }

  .news-popup {
    &--close {
      right: 0px !important;
    }
    &--content {
      padding: 20px !important;
      min-height: 250px !important;

      h1 {
        font-size: 24px !important;
        width: 100%;
      }
      .countdown {
        width: 290px !important;
      }
    }
  }
}

@keyframes spin{
  100%{transform:rotate(360deg);filter:hue-rotate(360deg)}
}
</style>
